export const contentTableConfig = {
  title: '内容中心通知列表',
  propList: [
    {
      prop: 'title',
      label: '标题',
      minWidth: '80'
    },
    {
      prop: 'content',
      label: '内容',
      minWidth: '180',
    },
    {
      prop: 'publishDate',
      label: '发布日期',
      width: '180'
    },
    {
      label: '操作',
      width: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
